const createDeeplink = (query: { [key: string]: any }) => {
  return (
    "oeapp://action?" +
    Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join("&")
  )
  // return "oeapp://action?" + new URLSearchParams(query).toString();
}

export default {
  mannerOE: () => createDeeplink({ type: "매너오이" }),
  mannerOEDelivery: (
    oeId: number,
    param: { scheduleId?: number; contentId?: number; diningGroupId?: number },
  ) => {
    const query = {
      type: "매너오이전달",
      oeId,
    }
    const { scheduleId, contentId, diningGroupId } = param
    if (scheduleId) {
      // @ts-ignore
      query["scheduleId"] = scheduleId
    }
    if (contentId) {
      // @ts-ignore
      query["contentId"] = contentId
    }
    if (diningGroupId) {
      // @ts-ignore
      query["diningGroupId"] = diningGroupId
    }
    return createDeeplink(query)
  },
  reportDetail: (reportId: number) =>
    createDeeplink({ type: "신고", reportId }),
  myFeedDetail: (feedOwnerId: number, feedId: number) =>
    createDeeplink({ type: "개인피드", feedOwnerId, feedId }),
  myFeedComment: (feedOwnerId: number, feedId: number, commentId: number) =>
    createDeeplink({ type: "개인피드", feedOwnerId, feedId, commentId }),
  gatheringHome: (gatheringId: number) =>
    createDeeplink({ type: "모임", gatheringId }),
  gatheringMember: (gatheringId: number) =>
    createDeeplink({ type: "모임멤버", gatheringId }),
  gatheringJoinRequest: (gatheringId: number, requestId: number) =>
    createDeeplink({ type: "가입신청", gatheringId, requestId }),
  chatRoom: (room: string) => createDeeplink({ type: "채팅방", room }),
  gatheringFeedDetail: (gatheringId: number, feedId: number) =>
    createDeeplink({ type: "모임피드", gatheringId, feedId }),
  gatheringFeedComment: (
    gatheringId: number,
    feedId: number,
    commentId: number,
  ) =>
    createDeeplink({
      type: "모임피드댓글",
      gatheringId,
      feedId,
      commentId,
    }),
  gatheringNoticeDetail: (gatheringId: number, noticeId: number) =>
    createDeeplink({ type: "모임공지", gatheringId, noticeId }),
  gatheringNoticeComment: (
    gatheringId: number,
    noticeId: number,
    commentId: number,
  ) =>
    createDeeplink({
      type: "모임공지댓글",
      gatheringId,
      noticeId,
      commentId,
    }),
  gatheringScheduleDetail: (gatheringId: number, scheduleId: number) =>
    createDeeplink({ type: "모임일정", gatheringId, scheduleId }),
  gatheringScheduleComment: (
    gatheringId: number,
    scheduleId: number,
    commentId: number,
  ) =>
    createDeeplink({
      type: "모임일정댓글",
      gatheringId,
      scheduleId,
      commentId,
    }),
  gatheringVoteDetail: (gatheringId: number, voteId: number) =>
    createDeeplink({
      type: "모임투표",
      gatheringId,
      voteId,
    }),
  gatheringVoteComment: (
    gatheringId: number,
    voteId: number,
    commentId: number,
  ) =>
    createDeeplink({
      type: "모임투표댓글",
      gatheringId,
      voteId,
      commentId,
    }),
  gatheringWishList: (gatheringId: number) =>
    createDeeplink({ type: "모임찜하기목록", gatheringId }),
  hotGatheringList: (regionCode: string) =>
    createDeeplink({ type: "지역인기모임", regionCode }),
  webLink: (link: string) => createDeeplink({ type: "웹링크", link }),
  contentHostProfile: (hostId: number) =>
    createDeeplink({ type: "호스트프로필", hostId }),
  contentDetail: (contentId: number) =>
    createDeeplink({ type: "콘텐츠", contentId }),
  contentSettlement: (contentId: number) =>
    createDeeplink({ type: "콘텐츠정산", contentId }),
  contentJoinList: () => createDeeplink({ type: "참가콘텐츠" }),
  contentWishList: (contentId: number) =>
    createDeeplink({ type: "콘텐츠찜하기목록", contentId }),
  contentReviewDetail: (reviewId: number, contentId: number) =>
    createDeeplink({ type: "콘텐츠후기", reviewId, contentId }),
  contentReviewList: (hostId: number) =>
    createDeeplink({ type: "콘텐츠후기목록", hostId }),
  tab: (tab: "홈탭" | "모임찾기" | "즐길거리탭" | "피드탭" | "더보기") =>
    createDeeplink({ type: tab }),
  emoticonPurchase: (groupId: number) =>
    createDeeplink({ type: "이모티콘구매", groupId }),
  emoticonStore: () => createDeeplink({ type: "이모티콘스토어" }),
  greeting: (userId: number, gatheringId: number) =>
    createDeeplink({ type: "가입인사", userId, gatheringId }),
  userProfile: (userId: number) =>
    createDeeplink({ type: "개인프로필", userId }),
  hostProfile: (hostId: number) =>
    createDeeplink({ type: "호스트프로필", hostId }),
  reportUser: (userId: number, diningOrderId?: string) =>
    createDeeplink({ type: "유저신고", userId, diningOrderId }),
  gatheringMemberRanking: (gatheringId: number, yyyyMM: string) =>
    createDeeplink({ type: "모임멤버랭킹", gatheringId, yyyyMM }),
  makeGathering: (diningGroupId?: number) =>
    createDeeplink({ type: "모임만들기", diningGroupId }),
  makeGatheringSchedule: (gatheringId: number, recommendScheduleId?: number) =>
    createDeeplink({
      type: "모임일정만들기",
      gatheringId,
      recommendScheduleId,
    }),
  hotdeal: (productId: number) =>
    createDeeplink({ type: "핫딜상품상세", productId }),
  hotdealOrderDetail: (orderId: string) =>
    createDeeplink({ type: "핫딜상품주문상세", orderId }),
  diningIntroduce: () => createDeeplink({ type: "다이닝소개" }),
  diningOrderList: () => createDeeplink({ type: "다이닝주문내역" }),
  diningOrderDetail: (orderId: string) =>
    createDeeplink({ type: "다이닝주문상세", orderId }),
}
